import { XCircle, CheckCircle2 } from "lucide-react";
import { Reveal, Eyebrow } from "../Reveal";
import { PROBLEMS, SOLUTIONS, scrollToId } from "../../lib/site";

export const ProblemSolution = () => (
  <section
    id="why-us"
    data-testid="problem-solution-section"
    className="py-16 sm:py-24 lg:py-32 px-4 sm:px-8 lg:px-12 bg-[#070D24] border-y border-white/5 scroll-mt-20"
  >
    <div className="max-w-7xl mx-auto">
      <Reveal className="max-w-3xl space-y-4 mb-12 lg:mb-16">
        <Eyebrow>The Real Problem</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
          Spending On Ads But Not Getting{" "}
          <span className="gradient-accent-text">Quality Leads?</span>
        </h2>
        <p className="text-base sm:text-lg text-slate-300">
          You're not the problem — your strategy is. Here's the difference a
          performance-first agency makes.
        </p>
      </Reveal>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
        <Reveal delay={0.1}>
          <div
            data-testid="problem-card"
            className="h-full rounded-2xl border border-red-500/20 bg-red-500/[0.04] p-6 sm:p-8"
          >
            <span className="text-xs font-mono2 uppercase tracking-[0.25em] text-red-400 font-semibold">
              The Money Pit
            </span>
            <h3 className="font-display text-xl sm:text-2xl font-semibold text-white mt-2 mb-6">
              Before Ad Neurone
            </h3>
            <ul className="space-y-4">
              {PROBLEMS.map((p, i) => (
                <li key={i} className="flex items-start gap-3 text-sm sm:text-base text-slate-300">
                  <XCircle size={19} className="text-red-400 mt-0.5 shrink-0" />
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="h-full rounded-2xl p-px bg-gradient-to-br from-blue-500/60 via-white/10 to-violet-500/60">
            <div
              data-testid="solution-card"
              className="h-full rounded-2xl bg-[#0B132B] p-6 sm:p-8"
            >
              <span className="text-xs font-mono2 uppercase tracking-[0.25em] text-cyan-400 font-semibold">
                The Neural Growth Engine
              </span>
              <h3 className="font-display text-xl sm:text-2xl font-semibold text-white mt-2 mb-6">
                With Ad Neurone
              </h3>
              <ul className="space-y-4">
                {SOLUTIONS.map((s, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm sm:text-base text-slate-200">
                    <CheckCircle2 size={19} className="text-emerald-400 mt-0.5 shrink-0" />
                    {s}
                  </li>
                ))}
              </ul>
              <button
                data-testid="why-us-cta-button"
                onClick={() => scrollToId("lead-form")}
                className="mt-8 inline-flex items-center gap-2 gradient-bg text-white text-sm font-semibold px-6 py-3 rounded-full hover:brightness-110 hover:shadow-[0_0_28px_rgba(99,102,241,0.5)] transition-[box-shadow,filter] duration-300"
              >
                Fix My Funnel — Free Call
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
